// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: "3.3.2",

  // LOGIN
  //base_url: "http://localhost:18194",
  base_url: "https://comisiones.librecode.com.mx/api",
  //loginEndpoint: "/user/applogin",
  loginEndpoint: "/login/signIn",
  appId: 9,

  // QAV2 LOCAL
  //services_url: "http://localhost:18194",
  services_url: "https://comisiones.librecode.com.mx/api",

  // QAV2
  //services_url: 'http://192.168.230.22:18194',

  //appId:9,
  //loginEndpoint:'/user/applogin'

  //LOCAL
  //services_url: 'http://localhost:17805',
  //services_url: 'http://localhost:17803', //QA
  //services_url: 'http://localhost:17194', //PRODLOCAL

  // TODO: reemplazar con las URLs reales del backend antes de desplegar.
  hypermatrix_url: "https://TU-DOMINIO-AQUI",
  promotor_url: "https://TU-DOMINIO-AQUI",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
